import React, { useEffect } from 'react'

import { Box, Grid, Button, Typography } from '@mui/material'

import { PickingProductList } from './PickingProductList'

import { PickingRoute } from '../../../interfaces/Picking/Picking'

import usePickingRouteDetails from '../../../hooks/usePickingRouteDetails'

import { Loading } from '../../UI'

import { PickingRouteReviewTable } from './PickingRouteReview/PickingRouteReviewTable'

import { PickingRouteContext } from '../../../components/Picking/PickingRouteContext'
import { eTypePickingRoute } from '../../../enums/eTypePickingRoute'

interface PickingRouteReviewProps {
  pickingRoute: PickingRoute | undefined
  reviewType?: number
  returnPreviousStep?: () => void
}

export const PickingRouteReview: React.FC<PickingRouteReviewProps> = ({
  pickingRoute,
  reviewType = 1
}) => {
  const { previousStep, setStep } = React.useContext(PickingRouteContext)

  const {
    loading,
    error,
    productDetails,
    getPickingRouteProductDetails,
    getPickingRouteProductDetailsProgress
  } = usePickingRouteDetails()

  const returnToPreviousStep = () => {
    setStep(previousStep)
  }

  useEffect(() => {
    if (reviewType === 1) {
      getPickingRouteProductDetails(pickingRoute?.pickingRouteId || 0)
    } else if (reviewType === 2) {
      getPickingRouteProductDetailsProgress(pickingRoute?.pickingRouteId || 0)
    } else {
      getPickingRouteProductDetails(pickingRoute?.pickingRouteId || 0)
    }
  }, [getPickingRouteProductDetails, getPickingRouteProductDetailsProgress])

  if (loading) return <Loading />

  return (
    <Box
      display='flex'
      flex='1'
      flexDirection='column'
      justifyContent='space-around'
    >
      <Grid
        container
        spacing={3}
        direction='column'
        alignItems='center'
        justifyContent='center'
      >
        <Grid item xs={12}>
          <Typography variant='h5' component={Box} align='center'>
            {`Detalle Ruta ${
              pickingRoute?.typePickingRouteId === eTypePickingRoute.RTV
                ? `RTV${pickingRoute?.pickingRouteId}`
                : pickingRoute?.pickingRouteId
            }`}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <PickingRouteReviewTable
            error={error}
            productDetails={productDetails}
            ot={pickingRoute?.workOrders}
            typePickingRouteId={pickingRoute?.typePickingRouteId}
          />
        </Grid>
        <Grid item xs={12}>
          <PickingProductList pickingProductList={productDetails} />
        </Grid>
        <Grid item xs={12}>
          <Button
            variant='contained'
            color='primary'
            onClick={returnToPreviousStep}
            size='small'
            fullWidth
          >
            Volver
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}
